// src/components/UserInfo.js
import React from 'react';
import defaultUserImage from '../assets/images/user.webp';
import { Mail, Phone, Crown, User } from 'lucide-react';

const formatPhoneNumber = (phone) => {
    if (!phone) return "";
    const cleaned = ('' + phone).replace(/\D/g, '');
    const matchMobile = cleaned.match(/^(\d{2})(\d{5})(\d{4})$/);
    if (matchMobile) return `(${matchMobile[1]}) ${matchMobile[2]}-${matchMobile[3]}`;
    const matchLandline = cleaned.match(/^(\d{2})(\d{4})(\d{4})$/);
    if (matchLandline) return `(${matchLandline[1]}) ${matchLandline[2]}-${matchLandline[3]}`;
    return phone;
};

function UserInfo({ user, hasSubscription }) {
    if (!user) return null;

    return (
        <div className="relative bg-gradient-to-br from-[#528a89] to-[#3a6362] p-8 md:p-10 rounded-[2rem] shadow-xl overflow-hidden text-white flex flex-col md:flex-row items-center md:items-start gap-6 md:gap-8">
            
            {/* Decorações de fundo */}
            <div className="absolute -top-20 -right-20 w-64 h-64 bg-white/10 rounded-full blur-3xl pointer-events-none"></div>
            <div className="absolute -bottom-20 -left-20 w-48 h-48 bg-[#dbcdac]/10 rounded-full blur-2xl pointer-events-none"></div>

            {/* Avatar */}
            <div className="shrink-0 relative z-10">
                <img 
                        className="w-28 h-28 md:w-32 md:h-32 rounded-full object-cover ..."
                        src={user.picture || defaultUserImage} 
                        alt='Foto de Perfil'
                        onError={(e) => { e.target.src = defaultUserImage; }}
                    />
            </div>
            
            {/* Dados do Usuário */}
            <div className="relative z-10 flex-1 text-center md:text-left flex flex-col justify-center h-full mt-2 md:mt-4">
                <div className="flex flex-col md:flex-row md:items-center gap-3 mb-3">
                    <h1 className="font-serif text-3xl md:text-4xl font-bold text-[#FFF5EE] tracking-tight">
                        {user.name || "Usuário"}
                    </h1>
                    
                    {/* Badge Condicional */}
                    {hasSubscription ? (
                        <span className="inline-flex items-center justify-center gap-1.5 bg-[#dbcdac] text-[#971253] text-[10px] font-bold uppercase tracking-widest px-3 py-1 rounded-full shadow-sm mx-auto md:mx-0">
                            <Crown size={12} strokeWidth={3} /> Membro Ativo
                        </span>
                    ) : (
                        <span className="inline-flex items-center justify-center gap-1.5 bg-white/20 text-white text-[10px] font-bold uppercase tracking-widest px-3 py-1 rounded-full backdrop-blur-sm mx-auto md:mx-0">
                            <User size={12} strokeWidth={3} /> Visitante
                        </span>
                    )}
                </div>

                <div className="flex flex-col sm:flex-row items-center md:justify-start gap-3 sm:gap-6 text-white/80 font-light text-sm mt-2">
                    <span className="flex items-center gap-2">
                        <Mail size={16} className="text-[#dbcdac] opacity-80" /> 
                        {user.email || "Email não cadastrado"}
                    </span>
                    {user.phone && (
                        <span className="flex items-center gap-2">
                            <Phone size={16} className="text-[#dbcdac] opacity-80" /> 
                            {formatPhoneNumber(user.phone)}
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
}

export default UserInfo;